// Rutas que puede abrir cada rol. El SUPER_ADMIN (o superusuario) puede abrir todas.
// Lo usan el menú lateral (para mostrar opciones) y las rutas protegidas (para bloquear la URL directa).
export const RUTAS_POR_ROL = {
    DOCTOR: ['/clinica/agenda', '/clinica/pacientes', '/clinica/servicios', '/clinica/graficos-consentimiento'],
    RECEPCIONISTA: ['/clinica/agenda', '/clinica/pacientes', '/clinica/registro-mensual', '/clinica/servicios', '/clinica/printers'],
    AYUDANTE: ['/clinica/agenda', '/clinica/pacientes', '/clinica/bodega'],
};

// Pantallas que no están en el menú pero a las que se llega desde Pacientes
// (p. ej. "crear presupuesto/receta" abre /clinica/consultas?patient_id=...).
const RUTAS_DESDE_PACIENTES = ['/clinica/consultas', '/clinica/historia-clinica', '/clinica/historia-visual', '/clinica/presupuestos-recetas'];

export const esSuperAdmin = (user) => user?.role_details?.name === 'SUPER_ADMIN' || !!user?.is_superuser;

export const puedeVerRuta = (user, path) => {
    if (esSuperAdmin(user)) return true;
    const rutas = RUTAS_POR_ROL[user?.role_details?.name] || [];
    if (rutas.includes('/clinica/pacientes') && RUTAS_DESDE_PACIENTES.includes(path)) return true;
    return rutas.includes(path);
};

// Primera pantalla a la que se envía a un usuario que no puede abrir la ruta pedida.
export const rutaInicial = (user) => {
    if (esSuperAdmin(user)) return '/';
    return (RUTAS_POR_ROL[user?.role_details?.name] || [])[0] || '/login';
};
